import styled from "styled-components";
import { Card, Input, Table } from "antd";
import { COLORS } from "../../../layout/theme";

export const Inner = styled.div`
	padding: 20px 10px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const HeaderBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const Title = styled.h1`
	margin: 0;
	font-size: 24px;
	font-weight: 700;
	color: ${COLORS.Secondary};
`;

export const Subtitle = styled.p`
	margin: 0;
	font-size: 14px;
	color: #64748b;
`;

export const FiltersCard = styled(Card)`
	border-radius: 20px;
	border: 1px solid #e2e8f0;
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

	.ant-card-body {
		padding: 18px;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: flex-end;

	.ant-picker,
	.ant-select-selector,
	.ant-input {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 14px !important;
	}

	.ant-picker {
		padding: 0 14px !important;
	}

	.ant-select-selector {
		padding: 0 14px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item,
	.ant-picker-input input,
	.ant-input {
		color: #334155 !important;
		font-size: 14px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector,
	.ant-input:hover,
	.ant-input:focus {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	.ant-select {
		min-width: 220px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select,
		.ant-input {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 180px;
	flex: 1 1 180px;
`;

export const FilterLabel = styled.span`
	font-size: 13px;
	font-weight: 600;
	color: #475569;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;
	padding-top: 24px;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
		padding-top: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const SummaryGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(
		${(props) => props.columns || 5},
		minmax(180px, 1fr)
	);
	gap: 16px;

	@media (max-width: 1200px) {
		grid-template-columns: repeat(2, minmax(180px, 1fr));
	}

	@media (max-width: 768px) {
		grid-template-columns: repeat(1, minmax(180px, 1fr));
	}
`;

export const SummaryCard = styled(Card)`
	border-radius: 20px;
	border: ${(props) =>
		props.borderColor ? `2px solid ${props.borderColor}` : "1px solid #e2e8f0"};
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
	overflow: hidden;

	.ant-card-body {
		padding: 10px 18px;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	&.highlight {
		background: linear-gradient(135deg, ${COLORS.Primary} 0%, #6d63ff 100%);
		border: none;

		.summary-label,
		.summary-caption,
		.summary-value {
			color: ${COLORS.White};
		}
	}
`;

export const SummaryLabel = styled.span.attrs({
	className: "summary-label",
})`
	font-size: 13px;
	color: #64748b;
	font-weight: 600;
`;

export const SummaryValue = styled.span.attrs({
	className: "summary-value",
})`
	font-size: 28px;
	font-weight: 700;
	color: #0f172a;
	line-height: 1.1;
`;

export const SummaryCaption = styled.span.attrs({
	className: "summary-caption",
})`
	font-size: 12px;
	color: ${(props) => (props.textColor ? props.textColor : "#94a3b8")};
	font-weight: ${(props) => (props.textColor ? 600 : 400)};
`;

export const TableCard = styled(Card)`
	border-radius: 20px;
	border: 1px solid #e2e8f0;
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

	.ant-card-body {
		padding: 16px;
	}
`;

export const AntdTable = styled(Table)`
	.ant-table {
		border-radius: 16px;
		overflow: hidden;
	}

	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};
		color: ${COLORS.White};
		font-weight: 600;
		border-bottom: none;
	}

	.ant-table-tbody > tr > td {
		background: ${COLORS.White};
		border-bottom: 1px solid #eef2f7;
		vertical-align: top;
	}

	.ant-table-tbody > tr:hover > td {
		background: #f8fafc !important;
	}

	.ant-table-container table > thead > tr:first-child th:first-child {
		border-radius: 16px 0 0 0;
	}

	.ant-table-container table > thead > tr:first-child th:last-child {
		border-radius: 0 16px 0 0;
	}

	.ant-pagination {
		margin-top: 16px;
	}
`;

export const TabsWrapper = styled.div`
	.ant-tabs-nav {
		margin-bottom: 16px;
	}

	.ant-tabs-tab {
		padding: 10px 14px !important;
		border-radius: 12px 12px 0 0;
		font-weight: 600;
	}

	.ant-tabs-tab-active {
		background: rgba(79, 70, 229, 0.06);
	}

	.ant-tabs-ink-bar {
		background: ${COLORS.Primary};
		height: 3px !important;
		border-radius: 999px;
	}
`;

export const DetailBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const DetailHeader = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	padding: 14px 16px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 16px;
`;

export const DetailItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 180px;
`;

export const DetailLabel = styled.span`
	font-size: 12px;
	font-weight: 600;
	color: #64748b;
`;

export const DetailValue = styled.span`
	font-size: 14px;
	font-weight: 600;
	color: #0f172a;
`;

export const ContentPreview = styled.div`
	max-height: 180px;
	overflow: auto;
	white-space: pre-wrap;
	word-break: break-word;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	padding: 10px 12px;
	color: #334155;
`;

export const AntdInput = styled(Input)`
	.ant-input-group .ant-input {
		height: 34px;
		border: 1px solid #cbd5e1;
		border-radius: 12px 0 0 12px;
		background-color: ${COLORS.White};
		text-align: center;
		padding: 5px 8px;
		font-weight: 600;
		color: #334155;
	}

	.ant-input-group .ant-input:hover,
	.ant-input-group .ant-input:focus {
		border: 1px solid #4f46e5;
		box-shadow: none;
	}

	.ant-input-group-addon {
		border: 1px solid #cbd5e1;
		border-left: 0;
		background-color: ${COLORS.White};
		padding: 0 10px;
		border-radius: 0 12px 12px 0;
		color: #64748b;
		font-weight: 600;
	}
`;

export const CompaginationDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-top: 18px;

	.ant-btn {
		width: 34px;
		height: 34px;
		border-radius: 999px;
		border: 1px solid #d1d5db;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: none;
	}
`;
